import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/login/page";
import SuccessStories from "../pages/success-stories/page";
import EmploymentPage from "../pages/employment/page";
import BusinessPage from "../pages/business/page";
import ItemDetailsPage from "../pages/item-details/page";
import AllJobsPage from "../pages/all-jobs/page";
import AllActivitiesPage from "../pages/all-activities/page";
import VisitorMaintenance from "../pages/maintenance/page";

import AdminDashboard from "../pages/admin/dashboard/page";
import ActivitiesPage from "../pages/admin/activities/page";
import JobsPage from "../pages/admin/jobs/page";
import UsersPage from "../pages/admin/users/page";
import PartnersPage from "../pages/admin/partners/page";
import StoriesPage from "../pages/admin/stories/page";
import AdminLocationsPage from "../pages/admin/locations/page";
import ContentPage from "../pages/admin/content/page";
import MessagesPage from "../pages/admin/messages/page";
import SettingsPage from "../pages/admin/settings/page";
import PermissionsPage from "../pages/admin/permissions/page";
import ProfilePage from "../pages/admin/profile/page";
import MaintenancePage from "../pages/admin/maintenance/page";
import ProtectedRoute from "../auth/ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/admin",
    element: <ProtectedRoute><AdminDashboard /></ProtectedRoute>,
  },
  {
    path: "/admin/activities",
    element: <ProtectedRoute><ActivitiesPage /></ProtectedRoute>,
  },
  {
    path: "/admin/jobs",
    element: <ProtectedRoute><JobsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/users",
    element: <ProtectedRoute><UsersPage /></ProtectedRoute>,
  },
  {
    path: "/admin/partners",
    element: <ProtectedRoute requiredRole="admin"><PartnersPage /></ProtectedRoute>,
  },
  {
    path: "/admin/stories",
    element: <ProtectedRoute requiredRole="admin"><StoriesPage /></ProtectedRoute>,
  },
  {
    path: "/admin/locations",
    element: <ProtectedRoute requiredRole="admin"><AdminLocationsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/content",
    element: <ProtectedRoute><ContentPage /></ProtectedRoute>,
  },
  {
    path: "/admin/messages",
    element: <ProtectedRoute><MessagesPage /></ProtectedRoute>,
  },
  {
    path: "/admin/settings",
    element: <ProtectedRoute requiredRole="admin"><SettingsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/permissions",
    element: <ProtectedRoute requiredRole="admin"><PermissionsPage /></ProtectedRoute>,
  },
  {
    path: "/admin/profile",
    element: <ProtectedRoute><ProfilePage /></ProtectedRoute>,
  },
  {
    path: "/admin/maintenance",
    element: <ProtectedRoute requiredRole="admin"><MaintenancePage /></ProtectedRoute>,
  },
  {
    path: "/success-stories",
    element: <SuccessStories />,
  },
  {
    path: "/employment",
    element: <EmploymentPage />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/item/:itemId",
    element: <ItemDetailsPage />,
  },
  {
    path: "/all-jobs",
    element: <AllJobsPage />,
  },
  {
    path: "/all-activities",
    element: <AllActivitiesPage />,
  },
  {
    path: "/maintenance",
    element: <VisitorMaintenance />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
